import React, { useRef } from 'react';
import { Text } from '@fluentui/react';
import { Marker, Popup } from 'react-leaflet';
import { LatLng } from 'leaflet';
import moment from 'moment';

import ItemTracking from '../../models/ItemTracking';

import 'leaflet';
import "leaflet-routing-machine";
declare let L : any;

const icon : L.Icon = L.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
});

interface ILeafletMapMarkerTrackingComponentProps {
    tracking: ItemTracking;
};

const getLatLng = (value: string) : LatLng => {
    const valueArray : string[] = value.split(',');
    return new LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
};

const LeafletMapMarkerTrackingComponent = (props: ILeafletMapMarkerTrackingComponentProps) => {
    const markerRef = useRef<L.Marker>(null);
    
    return (
        <>
            {
                props.tracking.PosicionGPS ? (
                    <Marker
                        ref={markerRef} 
                        position={getLatLng(props.tracking.PosicionGPS)}
                        icon={icon}>
                        <Popup>
                            <>
                                <Text variant="medium">
                                    <strong>
                                        {props.tracking.Nombre}
                                    </strong>
                                </Text>
                                <br/>
                                <Text>
                                    {props.tracking.Direccion}
                                </Text>
                                <br/>
                                <Text variant="xSmall">
                                    {
                                        props.tracking.FechaPosicion ? (
                                            `${moment(props.tracking.FechaPosicion).format("DD-MM-YYYY HH:mm")}h`
                                        ) : (
                                            "No disponible"
                                        )
                                    }
                                </Text>
                            </>
                        </Popup>
                    </Marker>
                ) : (
                    null
                )
            }
        </>
    );
};

export default LeafletMapMarkerTrackingComponent;
